<template>
    <div class="root">
      <template v-if="orderInfo && orderInfo.id>0">
      <van-form class="form-box" label-width="1.2rem">
        <van-field name="checkboxGroup" readonly label="订购货品">
          <template #input>
            <van-checkbox-group v-model="orderInfo.product" direction="horizontal">
              <van-checkbox name="流量卡" shape="square">流量卡</van-checkbox>
              <van-checkbox name="设备" shape="square">设备</van-checkbox>
            </van-checkbox-group>
          </template>
        </van-field>
        <van-field v-model="orderInfo.price" readonly label="商品金额" type="number" >
          <template #right-icon>
            <span>元</span>
          </template>
        </van-field>
        <van-field v-model="orderInfo.name" readonly label="联系姓名" />
      </van-form>
        <div class="price-box">
          <div class="price"><span>{{orderInfo.payStatus==1?'已支付':'待支付'}}&nbsp;&nbsp;</span><span>{{orderInfo.price}}</span><span>&nbsp;&nbsp;元</span></div>
        </div>
        <div class="qrcode">
          <qriously :value="payurl" :size="200"/>
        </div>
      <div v-if="orderInfo.payStatus==0" class="pay-btn" @click="pay">立即支付</div>
      <div v-else class="pay-btn paySuccess" >已支付</div>
      <div class="tips" v-if="orderInfo.payStatus==0">请点击立即支付 或 扫码支付</div>
      </template>
    </div>
</template>
<script>
  import Vue from 'vue';
  import VueQriously from 'vue-qriously';

  Vue.use(VueQriously);
    export default {
        data() {
            return {
              payurl:'',
              orderSn:'',
              orderInfo:{}
            };
        },
        watch:{

        },
        methods: {
          getOrderInfo(){
            this.fetchData('/yewuyuan/info',{orderSn:this.orderSn},res=>{
              if(res.code) {
                this.orderInfo = res.data
              }else {
                this.$toast(res.msg)
              }
            })
          },
          pay(){
            this.$toast.loading()
            this.fetchData('/yewuyuan/payinfo',{orderSn:this.orderSn},res=>{
              this.$toast.clear();
              if(res.code){
                WeixinJSBridge.invoke(
                  'getBrandWCPayRequest', res.data,
                  (payresult)=>{
                    if(payresult.err_msg == "get_brand_wcpay_request:ok" ) {
                      this.$toast.success('支付成功');
                      window.location.reload()
                    }
                  }
                );
              }else {
                this.$toast(res.msg)
              }
            })
          }
        },
        created: function () {
            this.orderSn = this.$route.query.orderSn;
            this.getOrderInfo()
            this.payurl = location.href
        }
    };
</script>
<style lang="scss" scoped>
.root{
  width: 7rem;
  margin: .4rem auto;
  .tips{
    margin-top: .24rem;
    text-align: center;
    font-size: .26rem;
  }
  .qrcode{
    width: 200px;
    margin: .4rem auto;
  }
  .price-box{
    text-align: center;
    .price{
      font-size: .8rem;
      color: #d94a4a;
      :last-child,:first-child{
        font-size: .4rem;
        color: #999988;
      }
    }
    .status{
      font-size: .4rem;
      color: #969799;
    }
  }
  .pay-btn{
    width: 100%;
    font-size: .24rem;
    height: .8rem;
    line-height: .8rem;
    color: #fff;
    text-align: center;
    border-radius: .2rem;
    background: #5daf34;
  }
  .paySuccess{
    background: #969799;
    color: #000;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/yewuyuanpayment.vue